import React, { useState } from 'react';
import axios from 'axios';
import './Publicar.css'; // Importando o CSS para este componente

const Publicar = () => {
  const [file, setFile] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [password, setPassword] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      alert('Por favor, selecione um arquivo antes de enviar.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      await axios.post('http://pmborrazopolis.no-ip.org:10130/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      alert('Arquivo enviado com sucesso!');
      setIsSubmitted(true);
    } catch (error) {
      alert('Erro ao enviar o arquivo: ' + error.message);
    }
  };

  const handlePasswordSubmit = () => {
    if (password === 'Diario202%') {
      setIsAuthorized(true);
    } else {
      alert('Senha incorreta.');
    }
  };

  if (!isAuthorized) {
    return (
      <div className="password-container">
        <h2>Digite a senha para acessar:</h2>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Senha"
        />
        <button onClick={handlePasswordSubmit}>Entrar</button>
      </div>
    );
  }

  return (
    <div className="container">
      <nav className="navbar">
      <div className="navbar-brand" style={{ textAlign: 'center', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '18px', color: 'white' }}>
    BOLETIM ELETRÔNICO DO MUNICÍPIO DE BORRAZÓPOLIS
</div>
      </nav>

      <section className="upload-section">
        <div className="form-container">
          <legend>INCLUSÃO DE PUBLICAÇÃO</legend>
          <div className="form-group">
            <label>Selecione o Arquivo:</label>
            <input type="file" onChange={handleFileChange} disabled={isSubmitted} />
          </div>
          <div className="form-group">
            <button onClick={handleUpload} disabled={isSubmitted}>
              {isSubmitted ? 'Enviado' : 'Upload'}
            </button>
          </div>
        </div>
      </section>

      <footer>
        <div className="footerdivide"></div>
        <div className="container">
          <p>
            PREFEITURA MUNICIPAL DE BORRAZÓPOLIS <br /> Desenvolvido Por <br /> Setor de T.I.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Publicar;
